<template>
  <el-table-column
    prop="representativeUser.last_name"
    sortable="custom"
    label="Képviselő"
    show-overflow-tooltip
    width="200px"
  >
    <template slot-scope="scope">
      {{ scope.row.representative_user_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'representativeUser.last_name',
  };
</script>
